import {
  getPlans as getPlansService,
  createPlan as createPlanService,
  updatePlan as updatePlanService,
} from "services/plans/plansService";
import {
  getPlansStart,
  getPlansSuccess,
  getPlansFailure,
  createPlanStart,
  createPlanSuccess,
  createPlanFailure,
  updatePlanStart,
  updatePlanSuccess,
  updatePlanFailure,
} from "./plansSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all plans
export const fetchPlans = () => async (dispatch) => {
  try {
    dispatch(getPlansStart());
    const response = await getPlansService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getPlansSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch plans";
      dispatch(getPlansFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch plans error:", error);
    const errorMsg = error?.response?.data?.meta?.message || error.message || "Failed to fetch plans";
    dispatch(getPlansFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Create a new plan
export const createNewPlan = (planData) => async (dispatch) => {
  try {
    dispatch(createPlanStart());
    const response = await createPlanService(planData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(createPlanSuccess(response.data));
      showSuccessToast(response?.meta?.message || "Plan created successfully!");
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to create plan";
      dispatch(createPlanFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create plan error:", error);
    const errorMsg = error?.response?.data?.meta?.message || error.message || "Failed to create plan";
    dispatch(createPlanFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update an existing plan
export const updateExistingPlan = (planId, planData) => async (dispatch) => {
  try {
    dispatch(updatePlanStart());
    const response = await updatePlanService(planId, planData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(updatePlanSuccess(response.data));
      showSuccessToast(response?.meta?.message || "Plan updated successfully!");
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to update plan";
      dispatch(updatePlanFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Update plan error:", error);
    const errorMsg = error?.response?.data?.meta?.message || error.message || "Failed to update plan";
    dispatch(updatePlanFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
